module.exports = __webpack_public_path__ + "media/images/front/robles_center-d24a1718823618bfd87b9a31a614c232.jpg";